









import { NotificationSingle } from "@/types/notification";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component
export default class AppNotificationBar extends Vue {
  @Action("notifications/remove") remove!: any;

  @Prop({ required: true })
  notification!: NotificationSingle;
}
